/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsWindow: {
  name: 'window';
  data: string;
} = {
  name: 'window',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 2A1.5 1.5 0 0 1 2 .5h12A1.5 1.5 0 0 1 15.5 2v12a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 14V2Zm8 12.5H14a.5.5 0 0 0 .5-.5V5.5h-6v9Zm-1-9v9H2a.5.5 0 0 1-.5-.5V5.5h6Zm.5-1h6.5V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v2.5H8Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
